/**
 * This file contains all polyfills needed for the support of IE 11.
 */
import "core-js/features/string/repeat";
import "core-js/stable";
import "core-js/es";
import "core-js/stage";
import "core-js/actual/structured-clone";
import "url-polyfill";
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";
// import "intersection-observer";

if (typeof ImageBitmap === "undefined") {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).ImageBitmap = class ImageBitmap {
    constructor(public width: number, public height: number) {}
  };
}

// Promise.withResolvers polyfill (needed by newer PDF.js versions)
if (!(Promise as unknown as { withResolvers: boolean }).withResolvers) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (Promise as unknown as { withResolvers: () => void }).withResolvers = function <T>() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let resolve: (value: T | PromiseLike<T>) => void;
    let reject: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return { promise, resolve: resolve!, reject: reject! };
  };
}

// Safari EasyViewer polyfill
if (!AbortSignal.any) {
  AbortSignal.any = function (signals) {
    const controller = new AbortController();
    for (const signal of signals) {
      if (signal.aborted) {
        controller.abort(signal.reason);
        return controller.signal;
      }
      signal.addEventListener("abort", () => controller.abort(signal.reason), { once: true });
    }
    return controller.signal;
  };
}
